export const arr1 = [
  { text: 'Хочешь увидеть, как выглядит музыка?' },
  // { text: 'Тогда сыграй на музыкальных инструментах, и ты увидишь графическое отображение каждой ноты сыгранных мелодий - их спектрограммы.' },
  // { text: 'Тогда играй на музыкальных инструментах и наблюдай, как выглядит каждая нота.' },
  // { text: 'А я помогу.' },
  // { text: 'Задание: Сыграй мелодии на музыкальных инструментах, нажимая на подсвеченные клавиши.', buttonTitle: 'Сыграть' },
  { text: 'Начни играть мелодию на металлофоне и посмотри, как выглядит частотный график и спектрограмма одной ноты.', buttonTitle: 'Сыграть' },
]

export const arr2 = [
  { text: 'Смотри, какую звуковую волну поднимает одна нота! По ней мы можем увидеть, какие частоты в ней преобладают. Чем выше пик ты видишь, тем громче был звук частоты, которой он соответствует.' },
  { text: 'А если наложить все дорожки так, чтобы пики сложились, и отобразить результат графически, то мы получим спектрограмму. Самые яркие участки — это самые насыщенные участки композиции.' },
  { text: 'Кстати, если ту же ноту проиграть на другом инструменте, ты увидишь совершенно другую картинку. У тебя будет возможность в этом убедиться чуть позднее.' },
  { text: 'А ещё ты видишь звуковую волну данной ноты.', buttonTitle: 'Продолжить' },
]

export const arr3 = [
  { text: 'Продолжай. Только не забывай наблюдать, как на графике расставляются локальные пики и как они преобразуются в ключевые точки на спектрограмме.', buttonTitle: 'Продолжить' },
]

export const arr4 = [
  { text: 'Робот уже помогает тебе: преобразует графики в спектрограммы и отмечает самые яркие точки на ней.' },
  { text: 'Продолжай дальше сам, но не забывай для каждой ноты отмечать пики (самые высокие точки) на звуковой волне.', buttonTitle: 'Продолжить' },
]

export const task1 = [
  { text: 'Начни играть мелодию на металлофоне и посмотри, как выглядит частотный график и спектрограмма одной ноты.' },
]

export const task2 = [
  { text: 'Задание: для каждой ноты отмечай пики (самые высокие точки) на звуковой волне.' },
]

// export const arr2 = [
//   { text: 'Каждая нота имеет свой рисунок.' },
//   { text: 'Чем ярче рисунок, тем громче она звучала.' },
//   { text: 'Чем больше световых полос - тем больше частот прозвучало.' },
//   { text: 'А ещё: ты только что сыграл одну и ту же мелодию, только на разных инструментах.', buttonTitle: 'Продолжить' },
// ]

// export const arr3 = [
//   { text: 'Так как музыка может быть записана с разным качеством, то и спектрограммы могут отличаться. Поэтому компьютер смотрит не на всю спектрограмму, а лишь на самые яркие точки. Давай поможем компьютеру увидеть их!' },
//   { text: 'Задание. Отметь самые яркие точки спектрограммы, кликнув на них мышкой.', buttonTitle: 'Продолжить' },
// ]

export const arr5 = [
  { text: 'Смотри, насколько похожими получились карты ключевых точек на спектрограммах!' },
  { text: 'Конечно же, это не случайность: у одной мелодии, даже сыгранной на разных инструментах, карты точек будут очень похожи.' },
  { text: 'Давай узнаем название мелодии и её автора?', buttonTitle: 'Продолжить' },
]

export const hint = [
  { text: 'В каждом столбце этой мелодии только одна самая яркая точка.' },
]

export const taskXylo = [
  { text: 'Задание: сыграй мелодии на музыкальных инструментах, нажимая на подсвеченные клавиши.', buttonTitle: 'Продолжить', key: 'xylo' },
]
